(function () {
  if (window.__BG_CARD_SIZE__) return; window.__BG_CARD_SIZE__ = true;

  function findCard(el){ try { return el.closest('.ProductItem, .product-card, .card, li, article'); } catch(e){ return null; } }

  function getPriceHook(card){
    if (!card) return null;
    return card.querySelector('.bg-price[data-bg-price]') ||
           card.querySelector('.ProductItem__PriceList, .card-information__price, .price-list, .price, [data-product-price]');
  }

  function getTemplate(card, variantId){
    if (!card) return null;
    var box = card.querySelector('.bg-price-templates');
    if (!box) return null;
    return box.querySelector('template[data-variant="'+ String(variantId) +'"]');
  }

  function swapPrice(card, variantId){
    try{
      var priceEl = getPriceHook(card);
      var tpl = getTemplate(card, variantId);
      if (priceEl && tpl) {
        // Clone so we don’t remove the original template
        var frag = tpl.content.cloneNode(true);
        priceEl.innerHTML = '';
        priceEl.appendChild(frag);
      }
    }catch(e){}
  }

  function updateQuickAdd(card, variantId){
    try{
      if (!card) return;
      card.querySelectorAll('form [name="id"], .quick-add__form [name="id"]').forEach(function(inp){
        inp.value = String(variantId);
      });
    }catch(e){}
  }

  function initGroup(group){
    try{
      var card = findCard(group);
      if (!card) return;
      var r = group.querySelector('.bg-size-radio:checked') || group.querySelector('.bg-size-radio');
      if (!r) return;
      swapPrice(card, r.dataset.variantId);
      updateQuickAdd(card, r.dataset.variantId);
    }catch(e){}
  }

  function initAll(){ document.querySelectorAll('.bg-size-group').forEach(initGroup); }

  // Change handler (capture so we never block theme/carousel)
  document.addEventListener('change', function(e){
    var r = e.target && e.target.closest && e.target.closest('.bg-size-radio');
    if (!r) return;
    var group = r.closest('.bg-size-group');
    var card = findCard(group);
    swapPrice(card, r.dataset.variantId);
    updateQuickAdd(card, r.dataset.variantId);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, {once:true});
  else initAll();

  // When sections/cards get re-rendered by the theme (carousels, quick views, etc.)
  document.addEventListener('shopify:section:load', initAll);
})();
